import SimpleContainer from "components/InputsMex/containers/SimpleContainer";
import {
  HideField,
  SeleccionarFecha,
  TextInputOnBlur
} from "components/InputsMex/inputs";
import {
  SimpleDropDownInputField,
  SimpleNumberIntInputField,
  SimpleTextInputField
} from "components/InputsMex/SimpleInputs";
import { emailRegex } from "components/InputsMex/validaciones";
import React, { useCallback, useEffect } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { validateNumberMaxLength, validateRequiredRule } from "../../utils/validations";

const CODIGO_OTRA_MARCA = -999;

const Form = ({
  loadingEstados,
  estados = [],
  marcas = [],
  municipios = [],
  onChangeEstado,
  loadingMunicipios,
  tiendas = [],
  onChangeMunicipio,
  loadingTiendas,
  isQrTienda,
}) => {
  const { setValue } = useFormContext();

  const marca = useWatch({
    name: "marca",
  });

  const isOtraMarca = marca?.value === CODIGO_OTRA_MARCA;

  useEffect(() => {
    setValue("marcaManual", "", { shouldValidate: true });
  }, [isOtraMarca, setValue]);

  const onChangeTienda = useCallback(
    (tienda) => {
      setValue("tienda.label", tienda.label, { shouldValidate: true });
      setValue("tienda.numero", tienda.numero, { shouldValidate: true });
      setValue("tienda.nombre", tienda.nombre, { shouldValidate: true });
      setValue("tienda.direccion", tienda.direccion, { shouldValidate: true });
    },
    [setValue]
  );

  return (
    <div className='container'>
      <div className='row justify-content-around'>
        <div className='col-md-6 col-xl-5 form-group'>
          <SimpleDropDownInputField
            label='Nombre del estado*'
            name='estado'
            options={estados}
            onChangeFn={onChangeEstado}
            rules={{ required: "Este campo es obligatorio" }}
            disabled={isQrTienda}
            loading={loadingEstados}
          />
        </div>

        <div className='col-md-6 col-xl-5 form-group'>
          <SimpleDropDownInputField
            label='Nombre del municipio*'
            name='municipio'
            loading={loadingMunicipios}
            options={municipios}
            onChangeFn={onChangeMunicipio}
            rules={{ required: "Este campo es obligatorio" }}
            disabled={isQrTienda}
          />
        </div>
        <div className='col-md-6 col-xl-5 form-group'>
          <SimpleDropDownInputField
            label='Número de tienda* (TDA)'
            name='tiendaObj'
            options={tiendas}
            loading={loadingTiendas}
            rules={{ required: "Este campo es obligatorio" }}
            onChangeFn={onChangeTienda}
            disabled={isQrTienda}
          />
        </div>
        <HideField name='tienda.numero' />
        <HideField name='tienda.label' />
        <div className='col-md-6 col-xl-5 form-group'>
          <SimpleTextInputField
            label='Nombre de la tienda'
            name='tienda.nombre'
            disabled
            rules={{ required: "Este campo es obligatorio" }}
          />
        </div>
        <div className='col-md-6 col-xl-5 form-group'>
          <SimpleTextInputField
            label='Dirección'
            name='tienda.direccion'
            disabled
            rules={{ required: "Este campo es obligatorio" }}
          />
        </div>
        <div className='col-md-6 col-xl-5 form-group'>
          <SimpleNumberIntInputField
            label='Número de terminal o caja* (TE)'
            name='terminal'
            maxLength={3}
            rules={{
              validate: validateNumberMaxLength(3, "Debe ingresar 3 números"),
            }}
          />
        </div>
        <div className='col-md-6 col-xl-5 form-group'>
          <SimpleNumberIntInputField
            label='Número de transacción* (TR)'
            name='numeroTransaccion'
            maxLength={5}
            rules={{
              validate: validateNumberMaxLength(5, "Debe ingresar 5 números"),
            }}
          />
        </div>

        <div className='col-md-6 col-xl-5 form-group'>
          <SimpleDropDownInputField
            label='Marca del producto*'
            name='marca'
            options={marcas}
            rules={{ required: "Este campo es obligatorio" }}
          />
        </div>

        {isOtraMarca && (
          <div className='col-md-6 col-xl-5 form-group'>
            <SimpleTextInputField
              label='Especifique la marca del producto*'
              name='marcaManual'
              maxLength={10}
              rules={{
                maxLength: {
                  value: 10,
                  message: "Solo puede ingresar 10 caracteres",
                },
                validate: {
                  required: validateRequiredRule(),
                },
              }}
            />
          </div>
        )}

        <div className='col-md-6 col-xl-5 form-group'>
          <SimpleTextInputField
            label='Código de Garantía* (PPC)'
            name='codigoGarantia'
            rules={{
              validate: {
                required: validateRequiredRule(),
              },
            }}
            // onBlur={onBlurPPC}
          />
          {/* <HideField name='ppcValido' defaultValue={false} /> */}
        </div>
        <div className='col-md-6 col-xl-5 form-group'>
          <SimpleContainer name='fechaCompra' label='Fecha de compra del artículo*'>
            <SeleccionarFecha
              name='fechaCompra'
              rules={{
                required: "Por favor seleccione una fecha",
                // ppc: validatePpc(isPpcValido),
              }}
            />
          </SimpleContainer>
        </div>
        <div className='col-md-6 col-xl-5 form-group'>
          <SimpleContainer name='fechaGarantia' label='Fecha de garantia*'>
            <SeleccionarFecha
              name='fechaGarantia'
              rules={{
                required: "Por favor seleccione una fecha",
              }}
            />
          </SimpleContainer>
        </div>
        <div className='col-md-6 col-xl-5 form-group'>
          <SimpleContainer
            name='precio'
            label='Precio de compra del producto'
            helpText='Escribir sin comas y con centavos'>
            <TextInputOnBlur
              inputProps={{ name: "precio" }}
              numerico
              rules={{ required: "Este campo es obligatorio" }}
            />
          </SimpleContainer>
        </div>
        <div className='col-md-6 col-xl-5 form-group'>
          <SimpleTextInputField
            label='Descripción del producto*'
            name='descripcionProducto'
            rules={{ validate: validateRequiredRule() }}
          />
        </div>
      </div>
      <div className='row justify-content-around mt-5 mb-4'>
        <div className='col-md-6 col-xl-5'>
          <h3 className='text-primary'>Datos personales</h3>
        </div>
        <div className='col-md-6 col-xl-5' />
      </div>

      <div className='row justify-content-around'>
        <div className='col-md-6 col-xl-5'>
          <SimpleTextInputField
            label='Nombres*'
            name='cliente.nombre'
            rules={{ validate: validateRequiredRule() }}
          />
        </div>
        <div className='col-md-6 col-xl-5'>
          <SimpleTextInputField
            label='Apellidos*'
            name='cliente.apellido'
            rules={{ validate: validateRequiredRule() }}
          />
        </div>
      </div>

      <div className='row justify-content-around mt-5 mb-4'>
        <div className='col-md-6 col-xl-5'>
          <h3 className='text-primary'>
            Compártenos tu contacto para enviarte tu garantía
          </h3>
        </div>
        <div className='col-md-6 col-xl-5' />
      </div>

      <div className='row justify-content-around'>
        <div className='col-md-6 col-xl-5'>
          <SimpleTextInputField
            label='Email*'
            name='cliente.correo'
            rules={{
              validate: {
                required: validateRequiredRule(),
              },
              pattern: {
                value: emailRegex,
                message: "Debe ingresar un correo válido",
              },
            }}
          />
        </div>
        <div className='col-md-6 col-xl-5'>
          <SimpleNumberIntInputField
            label='Número telefónico*'
            name='cliente.telefono'
            maxLength={10}
            rules={{
              validate: validateNumberMaxLength(10, "Debe ingresar 10 números"),
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default Form;
